import { useEffect, useState } from "react";
import IconAirplaneTakeoff from "../SvgIcons/IconAirplaneTakeoff";
import api from "../../services/axios";
import GlobalSearch from "../Header/GlobalSearch";

export default function EscalateTicketModal({ onSave,disabled }) {
  const [selectedButtons, setSelectedButtons] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [selectedAgent, setSelectedAgent] = useState(null);  
  const labels = ["FA", "GK", "Gulf", "Global Software"];

  useEffect(() => {
    const fetchAgents = async () => {
      try {
        const res = await api.post("/list_agent");
        if (Array.isArray(res.data.data)) {
          setRowData(res.data.data);
        }
      } catch (error) {
        console.error("Failed to fetch agents:", error);
      }
    };

    fetchAgents();
  }, []);

  const handleToggle = (label) => {
    setSelectedButtons((prev) => (prev === label ? null : label));
  };

const isActive = (label) => selectedButtons === label;


  const openModal = () => {
    setIsVisible(true);
    setTimeout(() => setIsOpen(true), 10);
  };

  const closeModal = () => {
    setIsOpen(false);
    setTimeout(() => {
      setIsVisible(false);
      setSelectedAgent(null);
      setSelectedButtons(null);
    }, 300);
  };

  const getFilteredAgents = () => {
  if (!selectedButtons) return [];

  const mapping = {
    FA: "Field Assist",
    GK: "Gulf Konnect",
    Gulf :"Gulf Oil",
    "Global Software": "Global Gulf Support",
  };

  const filterValue = mapping[selectedButtons];
  if (!filterValue) return [];

  return rowData.filter((agent) => (agent.Agents_Company === filterValue && agent.Status == 'Active'));
};


  const filteredAgents = getFilteredAgents();

 const handleSave = () => {
  const filtered = getFilteredAgents();
  if (filtered.length === 0) return;

  const recipientEmails = filtered.map((agent) => agent.Email_Id).join(",");

  const formData = {
    Status: "Escalated",
    escalated_to: selectedButtons,
    escalated_emails: recipientEmails, // include emails if needed
  };

  closeModal();

  if (onSave) {
    onSave(formData);
  }
};


  return (
    <>
      <button type="button" className="btn btngradiant sclateticket" onClick={openModal} disabled={disabled}>
        <IconAirplaneTakeoff /> Escalate Ticket
      </button>     

      {isVisible && (
        <div className={`modal-overlay ${isOpen ? "show" : ""}`}>
          <div className={`modal-content ${isOpen ? "show" : ""}`}>
            <div className="modal-header d-flex justify-content-between align-items-center mb-4 border-bottom pb-3">
              <h5 className="modal-title d-flex align-items-center">
                <div className="btn btngradiant sclate">
                  <IconAirplaneTakeoff />
                </div>{" "}
                Escalate Ticket Send To
              </h5>
              <button type="button" className="btn-close" onClick={closeModal} />
            </div>

            <div className="modal-body">
              <div className="d-flex flex-column email-form">
                <div className="selectedbutton d-flex gap-3 justify-content-center align-items-center">
                  {labels.map((label) => (
                    <button
                      key={label}
                      type="button"
                      className={`btn btngradiant ${isActive(label) ? "active" : ""}`}
                      onClick={() => handleToggle(label)}
                    >
                      <span>{label}</span>
                    </button>
                  ))}
                </div>

                <div className="moveover">
                  {/* <div className="customers-header">
                    <h1><strong>Escalate to:</strong></h1>
                  </div> */}
                  <div className="email-list">
                    {filteredAgents.length === 0 ? (
                      <p className="text-center w-100">No recent agents found.</p>
                    ) : (
                      filteredAgents.map((agent, index) => (
                        <div key={index} className="agent-item">
                          {agent.Name || agent.Email_Id || "Unnamed Agent"}
                       </div>

                      ))
                    )}
                  </div>
                </div>

                <div className="border-top pt-3 gap-3 mt-3 modal-footer w-100 d-flex justify-content-end">
                  <button type="button" className="btn cancelbtn" onClick={closeModal}>
                    Close
                  </button>
                  <button type="button" className="btn btngradiant" onClick={handleSave}>
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
